module.exports = __webpack_public_path__ + "static/media/thumbup.5d1c369d.svg";